import { useEffect, useState } from "react";
import { numberWithCommas } from "../../../shared/utils";
import { AlertMsg } from "../../../shared/components/alert-msg";
import OrderCancelModal from "./OrderCancelModal";
import OrderConfirmationModal from "./OrderConfirmationModal";
import { FiTrash2 } from "react-icons/fi";


const changeOrderStatusAction = async ({
    pageProps,
    payload,
    type,
    callback,
}: any) => {
    await pageProps.changeOrderStatus(payload, type, callback);
};
const getStoreOrders = async ({ pageProps, payload }: any) => {
    await pageProps.getStoreOrders(payload);
};

const EachProduct = ({
    product,
    index,
    setProductList,
    productList,
    productListSummary,
    setProductListSummary,
    setAllProductsList,
}: any) => {
    const [qty, setQty] = useState<string>(product?.quantity || "");
    const [amount, setAmount] = useState<number>(
        parseFloat(product?.quantity || 0) * product.price
    );

    const handleInputChange = (e: any, index: any, amountSum: any) => {
        const { value } = e.target;
        const list = [...productList];
        const listSummary = [...productListSummary];
        list[index]["actualQuantity"] = parseFloat(value);
        listSummary[index]["actualPrice"] = amountSum;

        setProductList(list);
        setProductListSummary(listSummary);
        setAmount(amountSum);
    };
    return (
        <div className="product_item">
            <div className="left_product_info">
                <div className="product_img">
                    <img src={product?.productUrl[0]} alt={product?.name} />
                </div>
                <div className="name_cats">
                    <div className="product_name">{product?.name}</div>
                    <div className="product_cats">
                        {product?.categories &&
                            Array.isArray(product?.categories) &&
                            product?.categories.length >= 1 &&
                            product?.categories.map((eachCat: any, index: number) => (
                                <span key={index}>
                                    {eachCat}
                                    {index < product?.categories.length - 1 ? ", " : ""}{" "}
                                </span>
                            ))}
                    </div>
                </div>
            </div>

            <div className="right_product_info">
                <div className="amount_qty_wrap">
                    <input
                        type="number"
                        value={numberWithCommas(qty)}
                        name={product?.productId}
                        onChange={(e: any) => {
                            let valueSet: any = numberWithCommas(e.target.value.trim());
                            setQty(valueSet);

                            if (e.target.value.trim().length >= 1) {
                                let amountSum =
                                    parseFloat(valueSet.trim().replace(/,/g, "")) *
                                    product?.price;
                                handleInputChange(e, index, amountSum);
                            } else {
                                handleInputChange(e, index, 0);
                            }
                        }}
                    />
                    <div className="amount_total">${amount.toFixed(2)}</div>
                </div>
                <div className="cost_per_unit">{product?.price} per unit</div>
            </div>

            <button
                className="delete_icon"
                onClick={() => {
                    setProductListSummary((prevList: any) =>
                        prevList.filter(
                            (_: any, indexNumber: number) => indexNumber !== index
                        )
                    );
                    setProductList((prevList: any) =>
                        prevList.map((item: any, indexNumber: number) =>
                            indexNumber === index ? { ...item, actualQuantity: 0 } : item
                        )
                    );
                    setAllProductsList((prevList: any) =>
                        prevList.filter(
                            (_: any, indexNumber: number) => indexNumber !== index
                        )
                    );
                }}

            >
                <FiTrash2 />
            </button>
        </div>
    );
};

export const AllProducts = ({
    pageProps,
    allProducts,
    initialTotalValue,
    chosenOrder,
    fetchPayload,
    setOrderStatus,
    setHideConfirmationModal,
    setShowOrderInfo,
    setIsCancel,
    isCancel,
    setOpenCancelModal,
    openCancelModal,
    chosenOrderInfo,
    setChosenOrderInfo
}: any) => {
    const [productListArray, setProductList] = useState<any[]>([]);
    const [allProductsList, setAllProductsList] = useState<any[]>(
        allProducts?.vendorProducts
    );
    const [productListSummary, setProductListSummary] = useState<any[]>([]);
    const [totalValue, setTotal] = useState<any>(initialTotalValue);
    const [openConfirmationModal, setOpenConfirmationaModal] =
        useState<boolean>(false);

    useEffect(() => {

        let filteredItems = allProducts?.vendorProducts.map((eachItem: any) => ({
            actualQuantity: eachItem?.quantity,
            productId: eachItem?.productId,
        }));
        let itemsSummary = allProducts?.vendorProducts.map((eachItem: any) => ({
            actualPrice: eachItem?.quantity * eachItem?.price,
            productId: eachItem?.productId,
            name: eachItem?.name,
            price: eachItem?.price,
            quantity: eachItem?.quantity,
            categories: eachItem?.categories,
            productUrl: eachItem?.productUrl

        }));
        setProductListSummary(itemsSummary);
        setProductList(filteredItems);

    }, []);
    let loggedAccountInfo: any = localStorage.getItem("mamiVendorXAuth") || "{}";
    loggedAccountInfo = JSON.parse(loggedAccountInfo);
    useEffect(() => {
        if (isCancel === true) {
            changeOrderStatusAction({
                pageProps,
                payload: {
                    orderNumber: chosenOrder?.request_data?.response?.orderNumber,
                    storeId: loggedAccountInfo?.selectedStore?.id,
                },
                type: "cancelled",
                callback: () => {
                    setOpenCancelModal(false);
                    setHideConfirmationModal(false);
                    getStoreOrders({
                        pageProps,
                        payload: fetchPayload,
                    });
                },
            });
        }
    }, [isCancel]);
    useEffect(() => {
        let totalAmount = productListSummary.reduce(
            (accum, item) => accum + item.actualPrice,
            0
        );
        setTotal(parseFloat(totalAmount).toFixed(2));
    }, [productListArray, productListSummary]);


    const confirmOrder = () => {
        const convertedVendorOrderProducts = productListSummary.map((item: any) => ({
            productId: item.productId,
            actualQuantity:
                item?.price && item?.price !== 0
                    ? (item?.actualPrice ?? 0) / item.price
                    : 0,
        }));
        let payload = {
            orderNumber: chosenOrder?.request_data?.response?.orderNumber,
            vendorUserId: loggedAccountInfo?.userProfile?.id,
            vendorOrderProducts: convertedVendorOrderProducts,
        };
        if (setOrderStatus) {
            const convertedVendorOrderProductsView = productListSummary.map((item: any) => ({
                productId: item.productId,
                actualQuantity:
                    item?.price && item?.price !== 0
                        ? (item?.actualPrice ?? 0) / item.price
                        : 0,
            }));

            setChosenOrderInfo((prev: any[]) => ({
                ...prev,
                vendorProducts: convertedVendorOrderProductsView
            }));



            setOrderStatus("is_confirmed");
        } else {
            changeOrderStatusAction({
                pageProps,
                payload,
                type: "is_confirmed",
                callback: () => {
                    setOpenConfirmationaModal(true);
                    setHideConfirmationModal(true);
                    getStoreOrders({
                        pageProps,
                        payload: fetchPayload,
                    });
                },
            });
        }
    };

    return (
        <>
            <div className="products_wrap">
                {pageProps?.changeOrderStatusRequest?.request_status !==
                    "CHANGE_ORDER_STATUS_SUCCESS" && (
                        <>
                            {allProducts?.vendorProducts &&
                                productListArray.length >= 1 &&
                                productListSummary.length >= 1 &&
                                productListSummary.map((eachProduct: any, index: any) => {
                                    return (
                                        <EachProduct
                                            key={eachProduct?.productId}
                                            setProductListSummary={setProductListSummary}
                                            setAllProductsList={setAllProductsList}
                                            productListSummary={productListSummary}
                                            productList={productListArray}
                                            setProductList={setProductList}
                                            index={index}
                                            product={eachProduct}
                                        />
                                    );
                                })}
                            {totalValue && (
                                <div className="total_summary">
                                    <div className="title_txt">Subtotal</div>
                                    <div className="total_amount">${totalValue}</div>
                                </div>
                            )}
                            {pageProps.changeOrderStatusRequest?.request_status ===
                                "CHANGE_ORDER_STATUS_FAILURE" && (
                                    <AlertMsg
                                        type="error"
                                        message={
                                            pageProps?.changeOrderStatusRequest?.request_data?.error || ""
                                        }
                                    />
                                )}

                            <div className="confirm_cta">
                                <button
                                    className="btn"
                                    onClick={confirmOrder}
                                    disabled={
                                        !!pageProps?.changeOrderStatusRequest?.is_request_processing || productListSummary.length === 0
                                    }
                                >
                                    {pageProps?.changeOrderStatusRequest?.is_request_processing ===
                                        true
                                        ? "Processing..."
                                        : "Confirm final price"}
                                </button>
                            </div>
                        </>
                    )}
            </div>
            {pageProps.changeOrderStatusRequest?.request_status ===
                "CHANGE_ORDER_STATUS_SUCCESS" &&
                isCancel && (
                    <AlertMsg
                        type="success"
                        message="Order has been successfully canceled"
                    />
                )}
            {openConfirmationModal && (
                <OrderConfirmationModal
                    handleClose={() => {
                        setShowOrderInfo(false);
                        setOpenConfirmationaModal(false);
                    }}
                    orderNumber={chosenOrder?.request_data?.response?.orderNumber}
                />
            )}
            {openCancelModal && (
                <OrderCancelModal
                    handleClose={() => {
                        setOpenCancelModal(false);
                        setHideConfirmationModal(false);
                    }}
                    orderNumber={chosenOrder?.request_data?.response?.orderNumber}
                    handleCancel={() => setIsCancel(true)}
                    pageProps={pageProps}
                />
            )}
        </>
    );
};
